import React from 'react';
import states from './states.json';

class SelectUSState extends React.Component {

  constructor(props) {
    super(props);
    this._handleChange = this._handleChange.bind(this);
  }

  _handleChange(event) {
    this.props.onChange(event.target.value);
  }

  render() {
    return (
      <select id={this.props.id} className={this.props.className} defaultValue={session.store.state.toUpperCase()}>
        {states.map(item =>
            <option
              key={item.abbreviation}
              value={item.abbreviation}>
              {item.name}
            </option>
        )}
      </select>
    );
  }
}

export default SelectUSState;
